import { Space } from "antd"
import cx from "clsx"
import { Button, Card, Icon, Image, Modal, Text, Title } from "components/common"
import { SvgIcAuthenticator } from "components/svg"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import styles from "../index.module.less"

const QRCodeScanView = ({ qRCode, setCurrentState }) => {
  const { t } = useTranslation()
  return (
    <Space direction="vertical" align="center" size={24}>
      <Space size={6} className="w-100 text-center" direction="vertical">
        <SvgIcAuthenticator width="40px" height="auto" />
        <Title level={2} className="text-center mbe-0 bold">
          {t("Setup Google Authenticator")}
        </Title>
        <Text type="secondary" className="semiBold lhn" style={{ maxWidth: 240 }}>
          {t("We have detected that you have not set up Google Authenticator.")}
        </Text>
      </Space>

      <div>
        <Text className="mbe-16" type="secondary">
          {t("Please follow the steps below to set up Google Authenticator:")}
        </Text>
        <ol className={cx(styles.lists, "gray-900 mbe-0")}>
          <li>
            {t("Click this")}
            <a
              target="_blank"
              className="bold text-underline"
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&pli=1"
            >
              {" "}
              {t("link")}{" "}
            </a>
            {t("to download the")} <strong> {t("Google Authenticator")} </strong> {t("app on your phone.")}
          </li>
          <li>
            {t(
              "Open Google Authenticator app on your phone, tap on “+”, select “Scan a barcode” and scan the code below."
            )}
          </li>
        </ol>
      </div>

      <Image src={qRCode || ""} height={170} width={170} preview={false} />

      <Button
        type="link"
        className="p-0 text-underline "
        text={t("Continue")}
        onClick={() => {
          setCurrentState("authCodeView")
        }}
        style={{
          height: "auto",
        }}
        block
      />
    </Space>
  )
}
export default QRCodeScanView
